import { format } from 'date-fns';
import { getLocaleFromLanguageOrCurrent } from 'src/utils/localeUtils';

const DateFormatter = 'MM/dd/yyyy';
const DateTimeFormatter = 'MM/dd/yyyy hh:mm a';
const DetailedDateTimeFormatter = 'EEEE MMMM d yyyy hh:mma';

export const formatDate = (
  date: string | Date | undefined | null,
  isTime = true,
  detailed = false
) => {
  if (!date) {
    return 'N/A';
  }
  const locale = getLocaleFromLanguageOrCurrent();

  const formatter = isTime
    ? detailed
      ? DetailedDateTimeFormatter
      : DateTimeFormatter
    : DateFormatter;
  return format(new Date(date), formatter, { locale });
};
